import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Urls } from './url';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../shared/service/authentication.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class HttpRequestBuilder {

  isLoading$: Observable<boolean>;

  private isLoadingSubject: Subject<boolean>;

  constructor(private _http: Http, private authenticationService: AuthenticationService) {
    this.isLoadingSubject = new Subject();
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }

  post(url: string, data: any) {
    this.isLoadingSubject.next(true);
    return this._http.post(`${Urls.getBaseUrlApi()}${url}`, data, this.getRequestOptions())
      .map((response: Response) => response)
      .catch((error: Response) => Observable.throw(error))
      .finally(() => this.isLoadingSubject.next(false));
  }

  get(url: string) {
    this.isLoadingSubject.next(true);
    return this._http.get(`${Urls.getBaseUrlApi()}${url}`, this.getRequestOptions())
      .map((response: Response) => response)
      .catch((error: Response) => Observable.throw(error))
      .finally(() => {
        this.isLoadingSubject.next(false);
      });
  }

  private getRequestOptions() {
    const credentials = this.authenticationService.getCredentials();
    const headers = new Headers();
    headers.append('Authorization', credentials);
    const options = new RequestOptions({ headers: headers });
    return options;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/http-request-builder.ts